const config = {
    apiUrl: 'http://localhost:8001/api',
    googleSignIn: 'http://localhost:8001/oauth/google?target=react',
    angularClientUrl: 'http://localhost:4200',
    amplitudeApiKey: '',
    defaultCompanyId: 22,
    defaultLocationId: 23,
    packageIds: {
        'Class A': 1,
        'Class B': 2,
        'Class B-A': 3,
        'None': 4,
    },
    stripePublicKey: 'pk_test_51KVilWEqooDHZwmck4VuUymwm3Bw75Fuyryrd0o3MiIlhowWiYpgJg0RgyrNIKufGU4lwTGYZxoIcsSSgP2ZaDmJ00Lb7M2O9G',
    sentryKey: '',
}

export default config;
